import React, {useEffect, useMemo, useRef, useState} from "react";
import {axios_tenant} from "../../../axios";
import "./IDSReference.css";
import Div from "@jumbo/shared/Div";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
//import config from '../../common/config';
//import * as XLSX from 'xlsx';

const IDSReference = () => {
    const [referenceIds, setReferenceIds] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [pdfLinks, setPdfLinks] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [isAllDone, setIsAllDone] = useState(false);
    const [isZipFileLoading, setIsZipFileLoading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [curr_count, setCurrCount] = useState(0);
    const [totalRefs, setTotal] = useState(0);
    const timer = React.useRef(null);

    //const [bulkUpload, setBulkUpload] = useState(false);

    const resultsRef = useRef(null);


    const handleInputChange = (e) => {
        setReferenceIds(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMessage("");
        setPdfLinks({});
        setIsLoading(true);
        setIsAllDone(false);
        setIsZipFileLoading(false);

        timer.current = true;
        setCurrCount(0);
        setTotal(0);
        setProgress(0);
        repeatedApiCall();
        try {
            /*if(bulkUpload){
              const f = await file.arrayBuffer();
              const wb = XLSX.read(f); // parse the array buffer
              const ws = wb.Sheets[wb.SheetNames[0]]; // get the first worksheet


              for (let z in ws) {
                if(z.toString()[0] === 'A'){
                    var id= ws[z].v;
                    var id_m= id.replace(/[\s/]/g, '');
                    idsArray.push(id_m.trim());
                }
              }
            } else {*/
            const idsArray = referenceIds.split(/[\n,]/).filter((id) => id.trim() !== "").map(id => id.replace(/[\s/]/g, ""));
            //}

            if (idsArray.length === 0) {
                setErrorMessage("Please enter at least one reference ID.");
                setIsLoading(false);
                return;
            }

            let initial_resp = {};
            for (let i = 0; i < idsArray.length; i++) {
                initial_resp[idsArray[i]] = {initialMsg: "Processing..."};
            }
            setPdfLinks(initial_resp);

            /*for (let i = 0; i < idsArray.length; i++) {
              let response = axios.post(`${config.API_BASE_URL}patents`, { patentReferenceIds: idsArray[i] }).then((response) => {
                setPdfLinks((prevPdfLinks) => {
                  const updatedPdfLinks = { ...prevPdfLinks };
                  updatedPdfLinks[idsArray[i]] = response.data[idsArray[i]];
                  //check if all has pdflinks then setIsLoading(false);
                  let checkIfAllDone = true;
                  for (let j = 0; j < idsArray.length; j++) {
                    if (
                      !updatedPdfLinks[idsArray[j]].hasOwnProperty('pdfLink') &&
                      !updatedPdfLinks[idsArray[j]].hasOwnProperty('error')
                    ) {
                      checkIfAllDone = false;
                      break;
                    }
                  }
                  if (checkIfAllDone) {
                    setIsLoading(false);
                  }
                  setIsAllDone(checkIfAllDone);
                  return updatedPdfLinks;
                });
              });
            }*/

            //for sequential enable next three lines of code.
            let response = await axios_tenant.post(`/ids/patents`, {patentReferenceIds: idsArray}, {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("TREXO_TENANT_AUTH_TOKEN")
                }
            });
            setPdfLinks(response.data);
            //set progress to 100%
            setProgress(100);
            setIsAllDone(true);
            //timer.current = false;
        } catch (error) {
            if (error.response) {
                setErrorMessage(error.response.data);
            } else {
                setErrorMessage("An error occurred while making the request.");
            }
        } finally {
            setIsLoading(false);
            setProgress(0);
            timer.current = false;
        }
    };

    const repeatedApiCall = async () => {
        timer.current = true;
        let idsArray = referenceIds.split(/[\n,]/).filter((id) => id.trim() !== "").map(id => id.replace(/[\s/]/g, ""));
        const fetchData = async () => {
            try {
                const response = await axios_tenant.get(`/ids/getProgress`, {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("TREXO_TENANT_AUTH_TOKEN")
                    }, params: {patentReferenceIds: idsArray}
                });
                // Start another request after receiving the response
                if (timer.current) {
                    setCurrCount(response.data.curr_count);
                    setTotal(response.data.total);
                    //setPdfLinks(response.data.pdfLinks);
                    setPdfLinks((prevPdfLinks) => {
                        const updatedPdfLinks = {...prevPdfLinks};
                        //updatedPdfLinks[idsArray[i]] = response.data[idsArray[i]];
                        //check if all has pdflinks then setIsLoading(false);
                        //let checkIfAllDone = true;
                        for (const property in response.data.pdfLinks) {
                            updatedPdfLinks[property] = response.data.pdfLinks[property];
                        }

                        return updatedPdfLinks;
                    });
                    let progress = (response.data.curr_count / response.data.total) * 100;
                    if (progress >= 100) {
                        timer.current = false;
                    }
                    if (isNaN(progress)) {
                        progress = 0;
                    }

                    setProgress(progress);
                    setTimeout(() => {
                        fetchData();
                    }, 3000);
                }


            } catch (error) {
                // Handle errors
                timer.current = false;
            }
        };
        // Initial request
        fetchData();
    };

    useEffect(() => {

        /*const timer = setInterval(() => {
          setProgress((oldProgress) => {
              if (oldProgress === 100) {
                  return 0;
              }
              const diff = Math.random() * 10;
              return Math.min(oldProgress + diff, 100);
          });
      }, 500);*/

        if (Object.keys(pdfLinks).length > 0) {
            resultsRef.current.scrollIntoView({behavior: "smooth", block: "start"});
        }
        /* return () => {
           clearInterval(timer);
       };*/

    }, [pdfLinks]);

    const validPdfLinks = useMemo(() => {
        const pdfLinksArray = Object.values(pdfLinks);
        return pdfLinksArray.filter(
            (linkObj) => linkObj.pdfLink && !linkObj.error
        );
    }, [pdfLinks]);

    const handleZipClick = () => {

        const pdfLinksArray = Object.values(pdfLinks);
        const validPdfLinks = pdfLinksArray.filter(
            (linkObj) => linkObj.pdfLink && !linkObj.error
        );

        // Check if any valid PDF links exist
        if (validPdfLinks.length === 0) {
            return;
        }

        const pdfLinksPayload = validPdfLinks.map((linkObj) => linkObj.pdfLink);
        setIsZipFileLoading(true);

        // Call the node server API to zip the PDF files
        axios_tenant.post(`/ids/patent/zip`, {pdfLinks: pdfLinksPayload}, {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("TREXO_TENANT_AUTH_TOKEN")
            }
        })
                    .then((response) => {
                        // Handle the response
                        window.open(response.data.zipUrl, "_blank");
                        // Save the zip file link to the database or perform any other necessary action
                    })
                    .catch((error) => {
                        // Handle the error
                    })
                    .finally(() => {
                        setIsZipFileLoading(false);

                    });
    };

    return (
        <div className="ids-reference">
            <h1 className="ids-reference-heading">IDS Reference Download</h1>
            <form className="ids-reference-form" onSubmit={handleSubmit}>
                <label htmlFor="patentIds">Enter Patent Id(s):</label>
                <br/>
                <textarea
                    className="ids-reference-textarea"
                    id="patentIds"
                    placeholder="Enter reference IDs"
                    value={referenceIds}
                    onChange={handleInputChange}
                />
                <br/>
                {/* <label htmlFor='fileUpload'>Or Upload a file</label>
        <input id='fileUpload' type="file" 
          onChange={handleFileChange} 
  />*/}
                <button className="ids-reference-button" type="submit" disabled={isLoading}>
                    {isLoading ? <div className="spinner-container">
                        <i className="fas fa-spinner spinner-icon"></i>
                    </div> : "Submit"}
                </button>
                <br/>

                {isLoading &&

                    <Div sx={{width: "60%"}}>
                        <LinearProgress variant="determinate" value={progress}/>
                    </Div>
                }
                {isLoading &&
                    <Typography variant="caption" component="div" color="text.secondary">
                        {`${curr_count} / ${totalRefs} done`}
                    </Typography>
                }


            </form>
            {errorMessage && <p className="ids-reference-error">{errorMessage}</p>}
            <div className="ids-reference-results-container" ref={resultsRef}>
                {Object.keys(pdfLinks).length > 0 && (
                    <div className="ids-reference-results">
                        <h2>Results</h2>
                        <table className="pdf-links-table">
                            <thead>
                            <tr>
                                <th>Reference ID</th>
                                <th>Reference Copy
                                    {isAllDone && validPdfLinks.length > 0 && <button
                                        className={`zip-icon ${isLoading || !isAllDone ? "disabled" : ""}`}
                                        disabled={isLoading || !isAllDone}
                                        onClick={handleZipClick}
                                    >
                                        | Download All as Zip {isZipFileLoading ? <i className="fa fa-spinner fa-spin"></i> : <i className="fa fa-file-archive"></i>}
                                    </button>}

                                </th>
                                {/*<th>Abstract + Original</th>*/}
                            </tr>
                            </thead>
                            <tbody>
                            {Object.keys(pdfLinks).map((referenceId, index) => {
                                const linkObj = pdfLinks[referenceId];
                                const fileName = pdfLinks[referenceId].fileName;

                                return (
                                    <tr key={index}>
                                        <td>{referenceId}</td>
                                        <td>
                                            {linkObj.error ? (
                                                <div className="error-message">
                                                    <span>Unable to download PDF</span>
                                                    <p className="error-text">{linkObj.error}</p>
                                                </div>
                                            ) : (
                                                linkObj.initialMsg ? (
                                                    <div className="initial-message">
                                                        <p>{linkObj.initialMsg}</p>
                                                    </div>
                                                ) : (
                                                    <a
                                                        href={linkObj.pdfLink}
                                                        target="_blank"
                                                        className="pdf-link"
                                                        download={fileName}
                                                    >
                                                        {fileName}
                                                    </a>
                                                )
                                            )}
                                        </td>
                                        {/* <td>
                {linkObj.abstractLink ? (
                  <a
                    href={linkObj.abstractLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="abstract-link"
                    download={`${referenceId}_Abstract.pdf`}
                  >
                    {referenceId}_Abstract.pdf
                  </a>
                ) : (
                  linkObj.initialMsg ? (
                    <div className="initial-message">
                    <p>{linkObj.initialMsg}</p>
                    </div>
                    ) :(
                  <span>No abstract available</span>
                    )
                )}
              </td>*/}
                                    </tr>
                                );
                            })}
                            </tbody>
                        </table>
                    </div>
                )}

            </div>
        </div>
    );
};

export default IDSReference;